export const FORCE_COMPLETE_LESSON = 'LESSONS.FORCE_COMPLETE_LESSON';
